<ng-template #helpPanel> <start-deal-jacket-help></start-deal-jacket-help></ng-template>
<section *ngIf="newDeal">
    <form [formGroup]="newDeal" (ngSubmit)="submit()">
        <div class="form-top">
            <h3 class="align-info">
                Add Deal #
                <mat-icon class="info-icon" matTooltip="For tracking purposes, it is useful to add the number your dealership uses to identify each deal.">
                    info
                </mat-icon>
            </h3>
            <mat-form-field>
                <mat-label>Deal #</mat-label>
                <input matInput formControlName="dealerDealNumber" />
                <mat-error>Cannot exceed 20 characters</mat-error>
            </mat-form-field>
        </div>

        <div class="step-item">
            <h2>Step 1: Update Buyer / Co-Buyer Information</h2>
        </div>

        <!-- buyer -->
        <div class="buyer-form-wrapper">
            <h3 class="align-info">
                Add / Update Buyer Information
                <mat-icon
                    class="info-icon"
                    matTooltip="Add the buyer's information or review what has been pre-populated to ensure it is correct. NOTE: the buyer's name should match what is in the DMS, as that is what will be presented on the deal forms. The buyer's first name, last name, email address, and phone are required."
                >
                    info
                </mat-icon>
            </h3>
            <p class="disclaimer">* Indicates a required field</p>
            <ng-container *ngIf="buyerFound && !isBuyerDealer">
                <p class="buyer-found">
                    Buyer found! Is this the right person? If not, please verify and re-enter the email address. If it is the right person but some of their
                    information needs to be updated, the buyer can do that through the profile screen when they log in.
                </p>
            </ng-container>
            <ng-container *ngIf="buyerFound && isBuyerDealer" class="buyer-found">
                <p class="buyer-found">The buyer's email address is already being used by a Dealer. Please use a different email address.</p>
            </ng-container>
            <ng-container *ngIf="duplicateBuyer">
                <p class="buyer-found">Buyer and Co-Buyer can't have the same email address.</p>
            </ng-container>

            <div class="buyer-form-one">
                <mat-form-field class="input-one" [class.mat-form-field-invalid]="isBuyerDealer || duplicateBuyer">
                    <mat-label>Buyer Email</mat-label>
                    <input matInput formControlName="buyerEmail" (blur)="findUser('buyer')" required="true" />
                    <mat-error>Invalid Email Address</mat-error>
                </mat-form-field>
                <mat-form-field class="input-two">
                    <mat-label>Buyer Mobile Phone</mat-label>
                    <input matInput formControlName="buyerPhone" required="true" appPhoneMask placeholder="(XXX) XXX-XXXX" maxlength="14" />
                    <mat-error>Invalid Phone Number</mat-error>
                </mat-form-field>
            </div>
            <div class="buyer-form-two">
                <mat-form-field class="input-one">
                    <mat-label>Buyer First Name</mat-label>
                    <input matInput formControlName="buyerFirstName" required="true" />
                    <mat-error>Invalid First Name</mat-error>
                </mat-form-field>
                <mat-form-field class="input-two">
                    <mat-label>Middle Initial / Name</mat-label>
                    <input matInput formControlName="buyerMiddleName" required="false" />
                    <mat-error>Invalid Middle Initial or Name</mat-error>
                </mat-form-field>
                <mat-form-field class="input-three">
                    <mat-label>Buyer Last Name</mat-label>
                    <input matInput formControlName="buyerLastName" required="true" />
                    <mat-error>Invalid Last Name</mat-error>
                </mat-form-field>
            </div>
            <div class="align-btn">
                <button (click)="clearBuyerFormGroup($event, 'buyer')" class="clear-all-btn">Clear All Fields</button>
            </div>
        </div>

        <!-- cobuyer -->
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h3 class="align-info">
                        Add Co-Buyer Information
                        <mat-icon
                            class="info-icon"
                            matTooltip="If there is a Co-Buyer on the deal, add their information or review what has been pre-populated to ensure it is correct. NOTE: the Co-Buyer's name should match what is in the DMS, as that is what will be presented on the deal forms. The Co-Buyer's first name, last name, email address, and phone are required. "
                            >info</mat-icon
                        >
                    </h3>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-container *ngIf="coBuyerFound && !isCoBuyerDealer">
                <p class="buyer-found">
                    Co-Buyer found! Is this the right person? If not, please verify and re-enter the email address. If it is the right person but some of their
                    information needs to be updated, the Co-Buyer can do that through the profile screen when they log in.
                </p>
            </ng-container>
            <p *ngIf="coBuyerFound && isCoBuyerDealer" class="buyer-found">
                The Co-Buyer's email address is already being used by a Dealer. Please use a different email address.
            </p>
            <ng-container *ngIf="duplicateBuyer">
                <p class="buyer-found">Buyer and Co-Buyer can't have the same email address.</p>
            </ng-container>
            <div formGroupName="coBuyerGroup">
                <div class="buyer-form-one">
                    <mat-form-field class="input-one" [class.mat-form-field-invalid]="isBuyerDealer || duplicateBuyer">
                        <mat-label>Co-Buyer Email</mat-label>
                        <input matInput formControlName="coBuyerEmail" (blur)="findUser('cobuyer')" />
                        <mat-error>Invalid Email Address</mat-error>
                    </mat-form-field>
                    <mat-form-field class="input-two">
                        <mat-label>Co-Buyer Mobile Phone</mat-label>
                        <input matInput formControlName="coBuyerPhone" appPhoneMask placeholder="(XXX) XXX-XXXX" maxlength="14" />
                        <mat-error>Invalid Phone Number</mat-error>
                    </mat-form-field>
                </div>
                <div class="buyer-form-two">
                    <mat-form-field class="input-one">
                        <mat-label>Co-Buyer First Name</mat-label>
                        <input matInput formControlName="coBuyerFirstName" />
                        <mat-error>Invalid First Name</mat-error>
                    </mat-form-field>
                    <mat-form-field class="input-two">
                        <mat-label>Middle Initial / Name</mat-label>
                        <input matInput formControlName="coBuyerMiddleName" required="false" />
                        <mat-error>Invalid Middle Initial or Name</mat-error>
                    </mat-form-field>
                    <mat-form-field class="input-three">
                        <mat-label>Co-Buyer Last Name</mat-label>
                        <input matInput formControlName="coBuyerLastName" />
                        <mat-error>Invalid Last Name</mat-error>
                    </mat-form-field>
                </div>
                <div class="align-btn">
                    <button (click)="clearBuyerFormGroup($event, 'cobuyer')" class="clear-all-btn">Clear All Fields</button>
                </div>
            </div>
        </mat-expansion-panel>
        <!-- <hr> -->
        <div class="underline"></div>

        <!-- vehicle -->
        <div class="step-item">
            <h2>Step 2: Update Vehicle Information</h2>
        </div>

        <div formGroupName="vehicleGroup">
            <h3 class="align-info">
                Add / Update Vehicle Information
                <mat-icon
                    class="info-icon"
                    matTooltip="Add the vehicle information or review what has been pre-populated to ensure it is correct. To change the vehicle, click on the Search for a Vehicle button to find the vehicle in your inventory. If the vehicle is not found, enter the information. VIN is required. "
                    >info</mat-icon
                >
            </h3>
            <div class="search-button-container">
                <button class="vehicle-search-button" type="button" (click)="openSearch()">
                    <mat-icon>search</mat-icon>
                    <span>Search for a Vehicle</span>
                </button>
            </div>
            <div class="vehicle-form-one">
                <mat-form-field class="input">
                    <mat-label>VIN</mat-label>
                    <input matInput formControlName="vin" maxlength="18" minlength="5" />
                    <mat-error>VIN is required</mat-error>
                </mat-form-field>
                <mat-form-field class="input">
                    <mat-label>Stock ID</mat-label>
                    <input matInput formControlName="stockNumber" />
                    <mat-error>Stock ID is required</mat-error>
                </mat-form-field>
                <mat-form-field class="input">
                    <mat-label>Mileage</mat-label>
                    <input matInput formControlName="mileage" />
                </mat-form-field>
            </div>
            <div class="vehicle-form-one">
                <mat-form-field class="input">
                    <mat-label>Price</mat-label>
                    <input matInput type="number" formControlName="priceInternet" />
                    <mat-error>Price is required</mat-error>
                </mat-form-field>
                <mat-form-field class="input">
                    <mat-label>New/Used</mat-label>
                    <mat-select class="form-control" formControlName="status">
                        <mat-option *ngFor="let status of carStatus" [value]="status.value">
                            {{ status.displayValue }}
                        </mat-option>
                    </mat-select>
                    <mat-error>Status is required</mat-error>
                </mat-form-field>
                <mat-form-field class="input">
                    <mat-label>Year</mat-label>
                    <input matInput formControlName="year" />
                </mat-form-field>
            </div>
            <div class="vehicle-form-one">
                <mat-form-field class="input">
                    <mat-label>Make</mat-label>
                    <input matInput formControlName="make" />
                </mat-form-field>
                <mat-form-field class="input">
                    <mat-label>Model</mat-label>
                    <input matInput formControlName="model" />
                </mat-form-field>
                <mat-form-field class="input">
                    <mat-label>Trim</mat-label>
                    <input matInput formControlName="trim" />
                </mat-form-field>
            </div>
            <div class="vehicle-form-two">
                <mat-form-field class="input">
                    <mat-label>Body Style</mat-label>
                    <input matInput formControlName="bodyStyle" />
                </mat-form-field>
                <mat-form-field class="input">
                    <mat-label>Ext. Color</mat-label>
                    <input matInput formControlName="extColor" />
                </mat-form-field>
                <mat-form-field class="input">
                    <mat-label>Int. Color</mat-label>
                    <input matInput formControlName="intColor" />
                </mat-form-field>
            </div>
            <div class="vehicle-form-two"></div>
        </div>

        <!-- trade-in vehicle -->
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h3 class="align-info">
                        Add Trade-In Vehicle Information
                        <mat-icon
                            class="info-icon"
                            matTooltip="Add the relevant details for the trade-in vehicle or review what has been pre-populated to ensure it is correct."
                            >info</mat-icon
                        >
                    </h3>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div formGroupName="tradeInGroup">
                <div class="vehicle-form">
                    <mat-form-field class="input">
                        <mat-label>VIN</mat-label>
                        <input matInput formControlName="vin" maxlength="18" minlength="5" />
                    </mat-form-field>
                    <mat-form-field class="input">
                        <mat-label>Year</mat-label>
                        <input matInput type="number" formControlName="year" />
                    </mat-form-field>
                </div>

                <div class="vehicle-form-one">
                    <mat-form-field class="input">
                        <mat-label>Make</mat-label>
                        <input matInput formControlName="make" />
                    </mat-form-field>
                    <mat-form-field class="input">
                        <mat-label>Model</mat-label>
                        <input matInput formControlName="model" />
                    </mat-form-field>
                    <mat-form-field class="input">
                        <mat-label>Trim</mat-label>
                        <input matInput formControlName="trim" />
                    </mat-form-field>
                </div>
                <div class="vehicle-form-two">
                    <mat-form-field class="input">
                        <mat-label>Body Style</mat-label>
                        <input matInput formControlName="bodyStyle" />
                    </mat-form-field>
                    <mat-form-field class="input">
                        <mat-label>Ext. Color</mat-label>
                        <input matInput formControlName="extColor" />
                    </mat-form-field>
                    <mat-form-field class="input">
                        <mat-label>Int. Color</mat-label>
                        <input matInput formControlName="intColor" />
                    </mat-form-field>
                </div>
                <div class="vehicle-form">
                    <mat-form-field class="input">
                        <mat-label>Mileage</mat-label>
                        <input matInput formControlName="mileage" />
                    </mat-form-field>
                    <mat-form-field class="input">
                        <mat-label>Value</mat-label>
                        <input type="number" matInput formControlName="priceInternet" />
                    </mat-form-field>
                </div>
            </div>
        </mat-expansion-panel>
        <div class="underline"></div>

        <!-- type of deal to associate correct forms -->
        <div class="step-item">
            <h2>Step 3: Initiate Deal Jacket</h2>
        </div>
        <div class="deal">
            <h3 class="align-info">
                How Do You Want to Add Documents to the Deal?
                <mat-icon
                    class="info-icon"
                    matTooltip="Select the method you want to use to add documents to the deal then click Start Deal Jacket to proceed to the next step. To learn more about each method, click its radio button and then open the When to Use dropdown panel. "
                >
                    info
                </mat-icon>
            </h3>

            <div class="radio-container">
                <mat-radio-group name="deal-options" (change)="onDealTypeChange($event)">
                    <mat-radio-button [checked]="true" [value]="SelectedDealType.Express" class="radio-btn"> Express Upload </mat-radio-button>
                    <mat-radio-button [value]="SelectedDealType.Custom" class="radio-btn"> Custom Deal Type </mat-radio-button>
                    <mat-radio-button [value]="SelectedDealType.Blank" class="radio-btn"> Blank Deal </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <ng-container *ngIf="selectGroup">
            <p class="select-tg">You must select a template group or select the deal type.</p>
        </ng-container>
        <ng-container *ngIf="selectedDealType === SelectedDealType.Custom">
            <ng-container *ngIf="customTemplateGroups.length <= 0">
                <p class="select-tg">No Custom Deal Types Available. Please create a Custom Deal Type first.</p>
            </ng-container>
            <div class="section-content">
                <mat-expansion-panel #customDealTypePanel hideToggle="true" class="mat-expansion-panel">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-expansion-panel-header-title">
                            When to use Custom Deal Type
                            <mat-icon *ngIf="!customDealTypePanel.expanded" class="question"> help </mat-icon>
                            <mat-icon *ngIf="customDealTypePanel.expanded" class="expanded-question"> help </mat-icon>
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-panel-description class="panel-desc">
                        <p>
                            Custom Deal Type is best for deals that use a common set of forms and documents. For example, all new vehicle cash deals with a
                            trade-in will have the same core set of forms. <b>Custom deal types must be set up in advance</b>. Once a custom deal type has been
                            created, it will appear in the dropdown list. When it is selected, its forms and documents will be added to the Deal Jacket.
                        </p>
                        <p>
                            Additional guidance on working with custom deal types is provided on the Deal Jacket screen. For more information on creating custom
                            deal types, check out the help and guidance in the Custom Deal Types function.
                        </p>
                    </mat-panel-description>
                </mat-expansion-panel>
                <div class="groups">
                    <template-groups [groups]="customTemplateGroups" (outEvent)="eventHandler($event)"> </template-groups>
                </div>
            </div>
        </ng-container>
        <div class="new-deal" *ngIf="selectedDealType === SelectedDealType.Express">
            <div class="section-content">
                <mat-expansion-panel #dealTypePanel hideToggle="true" class="mat-expansion-panel">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-expansion-panel-header-title">
                            When to use Express Upload
                            <mat-icon *ngIf="!dealTypePanel.expanded" class="question"> help </mat-icon>
                            <mat-icon *ngIf="dealTypePanel.expanded" class="expanded-question"> help </mat-icon>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-panel-description class="panel-desc">
                        <p>
                            Express Upload enables you to add PDF documents from your computer to a Deal Jacket without first adding the documents to the F&I
                            Forms library and/or creating Custom Deal Types. You can upload completed PDF documents or those that require signatures, initials
                            or other information.
                        </p>
                        <p>Additional guidance on working with Express Upload is provided on the Express Upload and Deal Jacket screens.</p>
                    </mat-panel-description>
                </mat-expansion-panel>
            </div>
        </div>
        <div class="new-deal" *ngIf="selectedDealType === SelectedDealType.DealType">
            <div class="section-content">
                <mat-expansion-panel #dealTypePanel hideToggle="true" class="mat-expansion-panel">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-expansion-panel-header-title">
                            When to use Deal Type
                            <mat-icon *ngIf="!dealTypePanel.expanded" class="question"> help </mat-icon>
                            <mat-icon *ngIf="dealTypePanel.expanded" class="expanded-question"> help </mat-icon>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-panel-description class="panel-desc">
                        <p>
                            Deal Type is best when none of the existing Custom Deal Types fits your needs and you do not need or want to create one.
                            <b> This option requires someone at the dealership to set up documents and forms in advance, using the F&I Forms function. </b>
                        </p>
                        <p>
                            With this option, first select the deal type characteristics (e.g., New or Used, Trade-In or No Trade-In). After you click Start
                            Deal Jacket, all the forms and documents that have been tagged as being relevant to a certain type of deal (e.g., New) will be added
                            to the Deal Jacket. You can then delete documents you do not need from the Documents Waiting sections by clicking the trashcan next
                            to the document name. You can also add forms and documents to the Deal Jacket using the documents that have been added in the F&I
                            Forms function of the application or upload PDF documents from your computer.
                        </p>
                    </mat-panel-description>
                </mat-expansion-panel>
                <div class="deal-type-container">
                    <deal-type [dealTypeSelections]="dealTypeSelections"></deal-type>
                </div>
            </div>
        </div>
        <div class="new-deal" *ngIf="selectedDealType === SelectedDealType.Blank">
            <div class="section-content">
                <mat-expansion-panel #blankDealPanel hideToggle="true" class="mat-expansion-panel">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-expansion-panel-header-title">
                            When to use Blank Deal
                            <mat-icon *ngIf="!blankDealPanel.expanded" class="question">help</mat-icon>
                            <mat-icon *ngIf="blankDealPanel.expanded" class="expanded-question">help</mat-icon>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-panel-description class="panel-desc">
                        <p>
                            Blank Deal provides maximum flexibility for situations where Express Upload and Custom Deal Type do not fit your needs. For example,
                            you may want to start a Deal Jacket to collect consumer documents like driver’s licenses and stips in preparation for a deal, before
                            the deal terms are finalized.
                        </p>
                        <p>
                            <b
                                >Using Blank Deal will not automatically add any forms or documents to the Deal Jacket; however, it may require someone at the
                                dealership to set up documents that will be added to the deal in advance, using the F&I Forms function.
                            </b>
                        </p>
                        <p>
                            Additional guidance on working with this method is provided on the Deal Jacket screen. For more information on creating F&I forms,
                            check out the help and guidance in the F&I Forms function.
                        </p>
                    </mat-panel-description>
                </mat-expansion-panel>
            </div>
        </div>

        <div class="start-button-container">
            <button mat-button class="primary grand" type="submit">Start Deal Jacket</button>
        </div>
    </form>
</section>

<create-deal-spinner *ngIf="isLoading"></create-deal-spinner>
